import React, { Component } from 'react'
import { connect } from 'react-redux'
import { app } from "../../../../config/constants";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {TextField} from 'material-ui'
import RaisedButton from 'material-ui/RaisedButton';
import { api } from "../../../../api";

class AppCampaignsUpdateComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			campaign: {
				data: {
					title: '',
					company: '',
					department: '',
					subject: '',
					type: '',
				},
				key: ''
			},
			companies: [],
			types: [],
			departments: [],
			subjects: []
		};

		this.handleTitleState = this.handleTitleState.bind(this);
		this.handleCompanySelectChange = this.handleCompanySelectChange.bind(this);
		this.handleDepartmentSelectChange = this.handleDepartmentSelectChange.bind(this);
		this.handleSubjectSelectChange = this.handleSubjectSelectChange.bind(this);
		this.handleTypeSelectChange = this.handleTypeSelectChange.bind(this);
		this.saveCampaign = this.saveCampaign.bind(this);

		// this.props.match.params.campaign_id;
	}

	componentWillMount() {
		app.database().ref('/cams/campaigns/' + this.props.match.params.campaign_id ).on( 'value', ( campaignSnap ) => {
			this.setState({
				campaign: {
					data: campaignSnap.val(),
					key: campaignSnap.key
				}
			});
		});

		app.database().ref('/cams/companies').orderByChild('title').on( 'value', ( companiesSnap ) => {
			let companies = [];
			let i = 0;

			new Promise( ( resolve, reject ) => {
				companiesSnap.forEach( ( company ) => {
					if ( company.val().title ) {
						companies.push({
							name: company.val().title,
							key: company.key
						});
					}

					if ( ++i === companiesSnap.numChildren() ) {
						resolve( companies );
					}
				});
			}).then( ( companies ) => {
				this.setState({
					companies: companies
				})
			})
		});

		app.database().ref('/cams/settings/campaigns/departments').on( 'value', ( departmentsSnap ) => {
			let departments = [];
			let i = 0;

			new Promise( ( resolve, reject ) => {
				departmentsSnap.forEach( ( department ) => {
					departments.push({
						name: department.val().name,
						key: department.key
					});

					if ( ++i === departmentsSnap.numChildren() ) {
						resolve( departments );
					}
				});
			}).then( ( departments ) => {
				this.setState({
					departments: departments
				})
			})
		});

		app.database().ref('/cams/settings/campaigns/subjects').on( 'value', ( subjectsSnap ) => {
			let subjects = [];
			let i = 0;

			new Promise( ( resolve, reject ) => {
				subjectsSnap.forEach( ( subject ) => {
					subjects.push({
						name: subject.val().name,
						key: subject.key
					});

					if ( ++i === subjectsSnap.numChildren() ) {
						resolve( subjects );
					}
				});
			}).then( ( subjects ) => {
				this.setState({
					subjects: subjects
				})
			})
		});

		app.database().ref('/cams/settings/campaigns/types').on( 'value', ( typesSnap ) => {
			let types = [];
			let i = 0;

			new Promise( ( resolve, reject ) => {
				typesSnap.forEach( ( type ) => {
					types.push({
						name: type.val().name,
						key: type.key
					});

					if ( ++i === typesSnap.numChildren() ) {
						resolve( types );
					}
				});
			}).then( ( types ) => {
				this.setState({
					types: types
				})
			})
		});
	}

	handleTitleState(event) {
		this.setState({
			campaign: {
				...this.state.campaign,
				data: {
					...this.state.campaign.data,
					title: event.target.value
				}
			}
		});
	}


	handleSelectChange(name, event, index, values) {
		this.setState({
			...this.state,
			campaign: {
				...this.state.campaign,
				data: {
					...this.state.campaign.data,
					[name]: values
				}

			}
		});
	}

	selectItems(items, name) {
		return items.sort( ( a, b ) => {

			if(a.name < b.name) return -1;
			if(a.name > b.name ) return 1;
			return 0;

		} ).map((item, key) => {
			return (
				<MenuItem
					key={key}
					insetChildren={true}
					checked={this.state.campaign[name] === item.key}
					value={item.key}
					primaryText={item.name}
				/>
			);
		});
	};

	handleCompanySelectChange(event, index, value) {
		this.setState({
			campaign: {
				...this.state.campaign,
				data: {
					...this.state.campaign.data,
					company: value
				}
			}
		})
	}

	handleTypeSelectChange(event, index, value) {
		this.setState({
			campaign: {
				...this.state.campaign,
				data: {
					...this.state.campaign.data,
					type: value
				}
			}
		})
	}

	handleSubjectSelectChange(event, index, value) {
		this.setState({
			campaign: {
				...this.state.campaign,
				data: {
					...this.state.campaign.data,
					subject: value
				}
			}
		})
	}

	handleDepartmentSelectChange(event, index, value) {
		this.setState({
			campaign: {
				...this.state.campaign,
				data: {
					...this.state.campaign.data,
					department: value
				}
			}
		})
	}

	saveCampaign() {
		app.database().ref( '/cams/campaigns').child(this.state.campaign.key).set(this.state.campaign.data).then( () => {
			api.snackbar.showMessage('De campagne is geüpdate');
		});
		// console.log( this.state.campaign.data );
	}

	render() {
		return (
			<div>
				<h1>Campagne Bewerken</h1>
				<div className="grid-x grid-margin-x grid-margin-y">
					<div className="medium-12 cell">
						<label>
							Naam
							<TextField name={'title'} id="title" fullWidth={true} value={this.state.campaign.data.title} onChange={this.handleTitleState} />
						</label>
					</div>
					<div className="medium-6 cell">
						<SelectField name={'type'} floatingLabelText={'Type'} value={this.state.campaign.data.type} maxHeight={200} fullWidth={true} onChange={this.handleTypeSelectChange}>
							{this.selectItems(this.state.types, 'type')}
						</SelectField>
					</div>
					<div className="medium-6 cell">
						<SelectField name={'subject'} floatingLabelText={'Onderwerp'} value={this.state.campaign.data.subject} maxHeight={200} fullWidth={true} onChange={this.handleSubjectSelectChange}>
							{this.selectItems(this.state.subjects, 'subject')}
						</SelectField>
					</div>
					<div className="medium-6 cell">
						<SelectField name={'department'} floatingLabelText={'Opdrachtgever'} value={this.state.campaign.data.department} maxHeight={200} fullWidth={true} onChange={this.handleDepartmentSelectChange}>
							{this.selectItems(this.state.departments, 'department')}
						</SelectField>
					</div>
					<div className="medium-6 cell">
						<SelectField name={'company'} floatingLabelText={'Bedrijf'} value={this.state.campaign.data.company} maxHeight={200} fullWidth={true} onChange={this.handleCompanySelectChange}>
							{this.selectItems(this.state.companies, 'company')}
						</SelectField>
					</div>
					<div className="medium-12 cell text-right">
						<RaisedButton
							label="Opslaan"
							primary={true}
							onClick={this.saveCampaign}
						/>
					</div>
				</div>



			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {}
};

export default connect(mapStateToProps)(AppCampaignsUpdateComponent)


// WEBPACK FOOTER //
// ./src/application/components/campaigns/components/update.js